import { AboutReducer } from "./about";
import { AccountsReducer } from "./accounts";
import { AwardsReducer } from "./awards";
import { BlogReducer } from "./blog";
import { CategoryReducer } from "./category";
import { ContactReducer } from "./contact";
import { EventsReducer } from "./events";
import { ExperiencesReducer } from "./experience";
import { FAQReducers } from "./faq";
import { GalleryReducer } from "./gallery";
import { MediaReducer } from "./media";
import { NavReducer } from "./navigation";
import { ServiceReducer } from "./service";
import { StaffsReducer } from "./staff";
import { UserReducer } from "./user";
import { VideoReducer } from "./videos";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  users: UserReducer,
  nav: NavReducer,
  contacts: ContactReducer,
  accounts: AccountsReducer,
  staff: StaffsReducer,
  services: ServiceReducer,
  media: MediaReducer,
  about: AboutReducer,
  faqs: FAQReducers,
  blogs: BlogReducer,
  awards: AwardsReducer,
  gallery: GalleryReducer,
  videos: VideoReducer,
  experiences: ExperiencesReducer,
  events: EventsReducer,
  category: CategoryReducer,
});
